// 调试工具
export class DebugHelper {
  static logIdConversion(originalId, realId, context = '') {
    console.log(`🔍 ID调试 [${context}]:`, {
      原始ID: originalId,
      真实ID: realId,
      时间: new Date().toLocaleString()
    });
  }

  static logAccessCheck(projectId, isPublic, isLoggedIn, isPublicFromUrl) {
    console.log(`🔐 访问检查:`, {
      项目ID: projectId,
      项目是否公开: isPublic,
      用户是否登录: isLoggedIn,
      URL是否包含isPublic: isPublicFromUrl,
      时间: new Date().toLocaleString()
    });
  }

  static logRouteChange(from, to) {
    console.log(`🔄 路由变化:`, {
      从: from?.path + (from?.query?.id ? `?id=${from.query.id}` : ''),
      到: to?.path + (to?.query?.id ? `?id=${to.query.id}` : ''),
      时间: new Date().toLocaleString()
    });
  }

  static getMappingInfo() {
    console.log(`📋 ID映射信息: 已移除随机ID功能`);
    return {};
  }

  static getReverseMappingInfo() {
    return {};
  }

  static checkMappingValidity() {
    return true;
  }

  static getMappingIssues() {
    return [];
  }

  static rebuildMapping() {
    console.log('重建ID映射: 已移除随机ID功能');
  }

  static diagnoseMapping(id) {
    console.log(`诊断ID: ${id}`);
    return `ID: ${id} (已移除随机ID功能)`;
  }

  static findMissingMapping() {
    console.log('查找丢失的映射: 已移除随机ID功能');
    return '已移除随机ID功能';
  }

  static clearMapping() {
    console.log('🗑️ ID映射已清除: 已移除随机ID功能');
  }

  static testIdConversion(realId) {
    console.log(`🧪 ID测试:`, {
      原始ID: realId,
      状态: '已移除随机ID转换功能'
    });
    
    return true;
  }
}

// 全局调试函数
window.debugHelper = DebugHelper; 